import { type ReactElement, } from "react";
import { SvgIconBase, } from "./Base";

export declare type XProps = {
	className?: string;
	style?: React.CSSProperties;
	scale?: number;
}

export const X = ({
	className = "",
	style = {},
	scale,
}: XProps): ReactElement => {
	return (
		<SvgIconBase
			className={className}
			style={style}
			scale={scale}
			width="24"
			height="24"
			viewBox="0 0 48 48"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			aria-label="X"
		>
			<title>X</title>
			<path
				d="M36.6526 3.80786H43.3995L28.6594 20.6548L46 43.5798H32.4225L21.7881 29.6759L9.61989 43.5798H2.86886L18.6349 25.5601L2 3.80786H15.9222L25.5348 16.5165L36.6526 3.80786ZM34.2846 39.5414H38.0232L13.8908 7.63413H9.87892L34.2846 39.5414Z"
				fill="currentColor"
			/>
		</SvgIconBase>
	);
};

